/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Trigger from './Trigger/index'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/TreatmentSelect/Content/Content"
  
}) {
let appointmentOverlayIsExternalAnyValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'is_external_any',
})
let treatmentsValueData = fromData.useDataFormat({ viewPath,
context: 'treatments',
format: fromFormat.hasZeroOrSingleItem,
})
let aggregateData = fromAggregate.any(appointmentOverlayIsExternalAnyValueData, treatmentsValueData)
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 offsetMainAxis={6}
 data="appointment_overlay.is_external_any"
 data="treatments"
 format="/Data/format.js hasZeroOrSingleItem"
 aggregate="/Data/aggregate.js any"
 disabled={aggregateData}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<Trigger
{...childProps}
  viewPath={`${viewPath}/Trigger`}
/>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}